import { KeyboardEvent, ReactNode } from 'react';

import { KeyboardKey } from '@this+that/utils';

export interface HitAreaProps {
  children: ReactNode;
  dataTestId?: string;
}

const stylesheet = {
  boundary: 'contents',
};

const PROPAGATION_STOPPED_KEYS: ReadonlySet<string> = new Set([
  KeyboardKey.ENTER,
  KeyboardKey.SPACE,
]);

export function HitArea({ children, dataTestId }: Readonly<HitAreaProps>) {
  const handleKeyDown = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (PROPAGATION_STOPPED_KEYS.has(e.key)) e.stopPropagation();
  };

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: handlers only contain events; the child control is the interactive element
    <span
      role="presentation"
      className={stylesheet.boundary}
      data-testid={dataTestId}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={handleKeyDown}
      onTouchStart={(e) => e.stopPropagation()}
      onTouchEnd={(e) => e.stopPropagation()}
    >
      {children}
    </span>
  );
}
